module.exports = __webpack_public_path__ + "static/media/arabic-1.9eaf39b4.jpeg";